import { useAuthStore } from '@stores/AuthStore';
import axios from 'axios';
import api from './api';

const apiUrl = import.meta.env.VITE_API_URL;

export function createSession(sendingData) {
    const authStore = useAuthStore();

    return axios.post(`${apiUrl}/v1/session`, sendingData, {
        headers: {
            Authorization: `Bearer ${authStore.userToken}`,
        },
    });
}

export function getSession(session_id) {
    const authStore = useAuthStore();

    return axios.get(`${apiUrl}/v1/session`, {
        headers: {
            Authorization: `Bearer ${authStore.userToken}`,
        },
        params: {
            session_id,
        },
    });
}

export function deleteSession(session_id) {
    const authStore = useAuthStore();

    return axios.delete(`${apiUrl}/v1/session`, {
        headers: {
            Authorization: `Bearer ${authStore.userToken}`,
        },
        params: {
            session_id,
        },
    });
}

export const getAttemptDetailsFetch = async (attempt_id) => {
    const { data } = await api.get('/v1/attempt_details', {
        params: { attempt_id },
    });
    return data;
};
